import { BaseService } from "../services/base.service";

const key = 'loaders';

export interface LoaderReducer {
  className: string;
  methodName: string;
  loaderName: string;
}

export default function loader(loaderName: string): (
  target: object,
  propertyKey: string,
) => void {
  return (target: object, methodName: string): void => {
    let loaders: LoaderReducer[] = Reflect.getMetadata(key, BaseService) || [];
    loaders.push({ className: target.constructor.name, methodName, loaderName });
    Reflect.defineMetadata(key, loaders, BaseService);
  };
}
